"use client";

import Image from "next/image";
/** One FAQ entry; optional image for future screenshots in answers. */
export type FaqAccordionItem = {
  id: string;
  question: string;
  answer: string;
  imageSrc?: string;
  imageAlt?: string;
};

interface FaqAccordionProps {
  items: FaqAccordionItem[];
}

/**
 * Renders accessible expand/collapse FAQ rows using native details/summary,
 * styled for the GRUV dark theme. Supports optional screenshot images per item.
 */
export function FaqAccordion({ items }: FaqAccordionProps) {
  return (
    <div className="gruv-faq__accordion" data-testid="faq-accordion">
      {items.map((item) => (
        <details key={item.id} className="gruv-faq__details">
          <summary className="gruv-faq__summary">
            <span className="gruv-faq__toggle" aria-hidden>
              <span className="gruv-faq__toggle-icon gruv-faq__toggle-icon--plus">+</span>
              <span className="gruv-faq__toggle-icon gruv-faq__toggle-icon--minus">−</span>
            </span>
            <span className="gruv-faq__question">{item.question}</span>
          </summary>
          <div className="gruv-faq__body">
            <p className="gruv-faq__answer">{item.answer}</p>
            {item.imageSrc ? (
              <figure className="gruv-faq__figure">
                <Image
                  src={item.imageSrc}
                  alt={item.imageAlt ?? ""}
                  width={640}
                  height={360}
                  className="gruv-faq__img"
                  sizes="(max-width: 1200px) 100vw, 1200px"
                />
              </figure>
            ) : null}
          </div>
        </details>
      ))}
    </div>
  );
}
